import Application from "../../../Application";
import { ICredentialsService } from "../../../authentication/service/CredentialsService";
import { ILanguageService } from "../../service/language/LanguageService";
import { ILocaleProvider } from "../../service/locale/LocaleProvider";

export default class ChangeLanguageInteractor {
  private application: Application;
  private languageService: ILanguageService;
  private credentialsService: ICredentialsService;
  private localeProvider: ILocaleProvider;

  constructor({
    application,
    languageService,
    credentialsService,
    localeProvider
  }: any) {
    this.application = application;
    this.languageService = languageService;
    this.credentialsService = credentialsService;
    this.localeProvider = localeProvider;
  }

  async execute(languageCode: string, portal: boolean) {
    this.credentialsService.setLanguage(languageCode);
    if (!portal) {
      await this.languageService.changeLanguage(languageCode);
    }
    // const translations = await this.localeProvider.fetch(languageCode);
    // this.localeProvider.addLocale(languageCode, translations);
    this.localeProvider.changeCurrentLanguage(languageCode);
    this.application.container.registerValue("language", languageCode);
  }
}
